/**
 * Event Tracking Component
 *
 * @author Steph Ritchie <sritchie@wayfair.com>
 * @copyright 2018 Wayfair LLC - All rights reserved
 */
import React from 'react';
import PropTypes from 'prop-types';
import TrackEvent from './track-event';

const TrackClick = props => (
  <TrackEvent
    events={{
      onClick: {
        type: props.type,
        name: props.name,
      },
    }}
    data={props.data}
    once={props.once}
    tracker={props.tracker}
  >
    {props.children}
  </TrackEvent>
);

TrackClick.propTypes = {
  tracker: PropTypes.object.isRequired,
  name: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  type: PropTypes.string,
  data: PropTypes.object,
  once: PropTypes.bool,
};

TrackClick.defaultProps = {
  once: false,
  data: {},
  type: 'action',
};

export default TrackClick;
